export default {
    methods: {
        hasPermission(permission,operator='and') {
            
            if (this.$store.get('login/userInfo').is_admin == 1)
                return true;
            if(Array.isArray(permission)){
                if(operator==='and')
                {
                    return permission.every(this.check);

                }else
                {
                    return permission.some(this.check)

                  }
            }    
            if (permission === 'noCheck')
                return true;
            else if (this.$store.get('login/userInfo').permissions.includes(permission))
                return true;
            else
                return false;
        },
        check(permission)
        {
            return this.$store.get('login/userInfo').permissions.includes(permission);
        }
    }
}